import * as Yup from "yup";
import { BaseEShopSchema } from "./BaseEShopSchema";

export const UpdateEShopSchema = BaseEShopSchema.shape({
    is_active: Yup.boolean(),
});
